import React from 'react';
import { Modal, Button, Row, Col, Badge } from 'react-bootstrap';

interface ViewUserModalProps {
  show: boolean;
  onHide: () => void;
  user: any;
}

const ViewUserModal: React.FC<ViewUserModalProps> = ({ show, onHide, user }) => {
  if (!user) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col md={6}>
            <strong>Name</strong>
            <div className="text-muted">{user.name}</div>
          </Col>
          <Col md={6}>
            <strong>Email</strong>
            <div className="text-muted">{user.email}</div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <strong>Mobile</strong>
            <div className="text-muted">{user.mobile}</div>
          </Col>
          <Col md={6}>
            <strong>Role</strong>
            <div>
              <Badge bg="secondary">{user.role}</Badge>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <strong>Status</strong>
            <div>
              <Badge bg={user.status === 'Active' ? 'success' : 'secondary'}>
                {user.status}
              </Badge>
            </div>
          </Col>
          {/* <Col md={6}>
            <strong>Join Date</strong>
            <div className="text-muted">{user.joinDate}</div>
          </Col> */}
        </Row>

        <Row>
          <Col md={6}>
            <strong>User ID</strong>
            <div className="text-muted small">{user.id}</div>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewUserModal;
